import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Badge, Box, Button, IconButton, Paper, Stack, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { setProductsAllFranch, setToken } from '../../actions/bank';
import { __ProcessFile } from '../../actions/analytics';
import { openRequestModal } from '../../actions/modals';
import StorefrontComponent from '../../components/StorefrontComponent';
import StudentStorefrontComponent from '../../components/StudentStorefrontComponent';
import TeacherStorefrontComponent from '../../components/TeacherStorefrontComponent';
import BankCustomersService from '../../services/bank-customers.service';
import BankReportService from '../../services/bank-report.service';
import store from './../../store';
import { toast } from 'react-toastify';

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
        background: '#00AB55',
    },
}));

export default function ShopPage(props) {
    const [vipDiscount, setVipDiscount] = useState('');
    const { t } = useTranslation();
    const { emulation } = store.getState().user;
    const roleId = useSelector(state => state.user.info.role_id);
    const cartItemCount = useSelector(state => state.bank.cart.length) || '0';
    const user = useSelector(state => state.bank);
    const balance = user.customer.balance || 0;
    const hasEmulation = emulation.length && emulation[emulation.length - 1].info;
    const dispatch = useDispatch();

    const getCheckExist = async () => {
        const res = await BankCustomersService.GetCheckExist();
        if (res && res.jwt) {
            dispatch(setToken(res));
            if ((roleId === 2 && emulation.length === 1) || (roleId === 3 && !emulation.length)) {
                await dispatch(setProductsAllFranch());
                getVipDiscount();
            }
        } else {
            toast.error(t('shopPage.errorUnauthorized'));
            return;
        }
    };

    async function getVipDiscount() {
        if ((roleId === 2 && emulation.length === 1) || (roleId === 3 && !emulation.length)) {
            const res = await BankCustomersService.GetVipDiscount();
            if (res && res.amount) {
                setVipDiscount(res.amount);
            } else {
                setVipDiscount('');
            }
        }
        return;
    }

    useEffect(() => {
        getCheckExist();
    }, []);

    async function __ProcessReportFile(data) {
        if (!data) return;
        const fileName = data.payload.fileName;
        const response = await BankReportService.DownloadDocument(fileName);

        __ProcessFile({ response, fileName });
    }

    async function downloadDocument() {
        try {
            const res = await BankReportService.GetProductsStock();
            await __ProcessReportFile(res);
        } catch (error) {
            console.error('Error downloading document: ', error);
        }
    }

    const handleOpenAddProductModal = () => {
        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    id: '',
                    header: t('shopPage.titleModalAddProduct'),
                    modaltype: 'AddProduct',
                },
            })
        );
    };

    const handleOpenCartModal = () => {
        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    id: '',
                    header: t('shopPage.titleModalCart'),
                    modaltype: 'Cart',
                },
            })
        );
    };

    const handleOpenAddDiscountForVipModal = () => {
        dispatch(
            openRequestModal({
                opened: true,
                data: {
                    id: '',
                    header: t('shopPage.titleModalAddVipDiscount'),
                    modaltype: 'AddDiscountForVip',
                    updateVipDiscount: getVipDiscount,
                },
            })
        );
    };

    return (
        <>
            <Stack spacing={2}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Stack direction="row" alignItems="center" spacing={2}>
                        <Typography style={{ width: '100px' }}>{t('shopPage.title')}</Typography>
                        {(roleId === 5 || hasEmulation.role_id === 5) && user.customer.role_id === 5 && (
                            <Tooltip title={t('shopPage.tooltip')}>
                                <IconButton onClick={() => handleOpenCartModal()}>
                                    <StyledBadge badgeContent={cartItemCount} color="secondary">
                                        <ShoppingCartIcon fontSize="large" />
                                    </StyledBadge>
                                </IconButton>
                            </Tooltip>
                        )}
                    </Stack>
                    {(roleId === 5 || hasEmulation.role_id === 5) && user.customer.role_id === 5 && (
                        <Box>
                            {t('shopPage.balance')}{' '}
                            <span
                                style={{
                                    display: 'inline',
                                    marginLeft: '5px',
                                    color: '#44A340',
                                }}
                            >
                                {balance} SoroCoins
                            </span>
                        </Box>
                    )}
                </Stack>
                {((roleId === 3 && !emulation.length) || hasEmulation.role_id === 3) && (
                    <Stack direction="row">
                        <Button
                            variant="contained"
                            onClick={handleOpenAddProductModal}
                            style={{
                                width: '150px',
                                padding: '5px',
                                borderRadius: '4px',
                                marginBottom: '15px',
                            }}
                        >
                            {t('shopPage.buttonAddProduct')}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={handleOpenAddDiscountForVipModal}
                            style={{
                                width: '150px',
                                padding: '5px',
                                borderRadius: '4px',
                                marginBottom: '15px',
                            }}
                        >
                            {t('shopPage.discount')} {vipDiscount ? `${vipDiscount}%` : ''}
                        </Button>
                        <Button
                            variant="contained"
                            onClick={downloadDocument}
                            style={{
                                padding: '5px',
                                borderRadius: '4px',
                                marginBottom: '15px',
                            }}
                        >
                            {`${t('Завантажити залишки')} (xlsx)`}
                        </Button>
                    </Stack>
                )}
            </Stack>
            {((roleId === 3 && !emulation.length) || hasEmulation.role_id === 3) && (
                <Paper elevation={0}>
                    <StorefrontComponent />
                </Paper>
            )}
            {((roleId === 4 && !emulation.length) || hasEmulation.role_id === 4) && (
                <Paper elevation={0}>
                    <TeacherStorefrontComponent />
                </Paper>
            )}
            {(roleId === 5 || hasEmulation.role_id === 5) && (
                <>
                    <StudentStorefrontComponent />
                </>
            )}
        </>
    );
}
